import { Col, Flex, Row, Tag, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../../Components/Button"
import Icon from "../../../../../../Icon"
import { ruleConditionsSummary } from "../../utils/ruleSummary"

import tableStyles from "../rulesTable.module.less"
import styles from "./categoryRules.module.less"

const { Text } = Typography

// Auto-submission exceptions: the ONLY way to stop a dispute being auto-submitted.
// Auto-submission itself is always on globally, so this section is framed purely as
// carve-outs: matching disputes (category / amount) skip auto-submission and go to the
// team for manual review. Laid out like every other Preferences section: title +
// description on the left, controls on the right, no card frame. The parent owns the
// add/edit/remove modals + confirm + notification.
const CategoryRules = ({ rules = [], locked, onAdd, onEdit, onRemove }) => {
  const { t } = useTranslation()

  return (
    <Row gutter={[24, 24]}>
      <Col flex="1 1 300px">
        <Flex vertical gap={4} style={{ maxWidth: 500 }}>
          <Text strong>{t("Auto-submission exceptions")}</Text>
          <Text type="secondary">
            {t(
              "Auto-submission is on for every dispute. Add an exception to hold specific disputes back for manual review instead."
            )}
          </Text>
        </Flex>
      </Col>

      <Col flex="0 1 420px">
        <Flex vertical gap={16}>
          {rules.length === 0 ? null : (
            <div className={tableStyles.table}>
              {rules.map((rule) => (
                <div key={rule.id} className={`${tableStyles.row} ${tableStyles.rowData}`}>
                  <span className={tableStyles.cWhen}>
                    {ruleConditionsSummary(rule.conditions, t)}
                  </span>
                  <span>
                    <Tag color="error">{t("Never auto-submit")}</Tag>
                  </span>
                  <span className={tableStyles.cOps}>
                    <Button
                      type="text"
                      size="small"
                      aria-label={t("Edit exception")}
                      disabled={locked}
                      icon={<Icon type="edit_small" />}
                      onClick={() => onEdit(rule.id)}
                    />
                    <Button
                      type="text"
                      size="small"
                      danger
                      aria-label={t("Remove exception")}
                      disabled={locked}
                      icon={<Icon type="delete" />}
                      onClick={() => onRemove(rule.id)}
                    />
                  </span>
                </div>
              ))}
            </div>
          )}

          <Flex align="center" justify="space-between" gap={12} wrap="wrap">
            <Button
              type="default"
              disabled={locked}
              icon={<Icon type="plus" />}
              onClick={onAdd}
              text={t("Add exception")}
            />
            <Typography.Link className={styles.how}>
              {t("How exceptions work")} <Icon type="open_link" />
            </Typography.Link>
          </Flex>
        </Flex>
      </Col>
    </Row>
  )
}

export default CategoryRules
